module.exports = __webpack_public_path__ + "src/assets/fonts/hero-pro-full-v2.svg?dc87de297e7f7591c54b7c6da39b855d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/hero-pro-full-v2.svg
// module id = 971
// module chunks = 1